import { type DocumentNode, gql } from '@apollo/client';

const assetsByCollectionIdPlaylist: DocumentNode = gql`
  query collection($id: ID!, $first: Int, $after: String, $q: String, $search: String) {
    collection(id: $id) {
      id
      name
      items(first: $first, after: $after, q: $q, search: $search, orderBy: "sequence") {
        edges {
          node {
            id
            contentObject {
              __typename
              ... on AssetNodeType {
                id
                name
                mediatype
                inpoint
                timecode
                formatSet {
                  edges {
                    node {
                      id
                      mimetype
                      filename
                      fmtType {
                        id
                        name
                        slug
                        suffix
                        downloadable
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default assetsByCollectionIdPlaylist;
